import { create } from 'zustand';

import { StorageRepository } from './repository/json';

export type State<T> = {
  state: T | undefined;
  lastChange: Date;
  setState: (state: T) => void;
  reset: () => void;
};

type Params<T> = {
  key: string;
  storage?: Storage;
  initialValue?: T;
  load?: (value: T | undefined) => T | undefined;
};

export function storageStore<T>({ key, storage = sessionStorage, initialValue, load }: Params<T>) {
  const repository = new StorageRepository<T>(storage);

  const value = repository.get(key, initialValue);
  const state = load ? load(value) : value;

  return create<State<T>>(set => ({
    state,
    lastChange: new Date(),
    setState: (state: T) => {
      repository.set(key, state);
      return set({ state, lastChange: new Date() });
    },
    reset: () => {
      repository.set(key, initialValue);
      return set({ state: initialValue, lastChange: new Date() });
    },
  }));
}
